import React, { useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaYoutube } from "react-icons/fa";
import "./HeaderTop.css";
import FormInfoModal from "../components/FormInfoModal";

const HeaderTop = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="header-top">
      <div className="header-top-content">
        
        <div className="left-content">
          <span className="inst-name">IESTP JUAN VELASCO ALVARADO</span>
          <FaPhoneAlt className="icon" />
          <span className="text">01 500 6177</span>
          <FaEnvelope className="icon" />
          <span className="text">secretaria.academica@iestpjva.edu.pe</span>
          <FaMapMarkerAlt className="icon" />
          <span className="text">Av. José Olaya N° 120, San Gabriel – V.M.T</span>
        </div>

        <div className="right-content">
           <button className="btn-info" onClick={() => setModalOpen(true)}>
            Solicitar Información
          </button>

          <a href="https://www.facebook.com/iestpjuanvelascoalvarado" target="_blank" rel="noreferrer">
            <FaFacebookF />
          </a>
          <a href="https://www.youtube.com/@iestpjuanvelascoalvarado3692" target="_blank" rel="noreferrer">
            <FaYoutube />
          </a>
        </div>
      </div>

    
      <FormInfoModal 
        isOpen={modalOpen} 
        onClose={() => setModalOpen(false)} 
        
      />
    </div>
  );
};

export default HeaderTop;
